// @ts-nocheck
import React from 'react';

const TONE_CLASS = {
  gray: 'mov-pill-tone-gray',
  green: 'mov-pill-tone-green',
  amber: 'mov-pill-tone-amber',
  red: 'mov-pill-tone-red',
  blue: 'mov-pill-tone-blue',
  ink: 'mov-pill-tone-ink',
};

/**
 * Pill — a small rounded label. Use the optional `dot` to show a colored
 * leading bullet that matches the tone.
 */
const Pill = ({ tone = 'gray', dot = false, className = '', children }) => (
  <span className={`mov-pill ${TONE_CLASS[tone] || TONE_CLASS.gray} ${className}`}>
    {dot && <span aria-hidden="true" className="mov-pill-dot" />}
    {children}
  </span>
);

export default Pill;
